export default {
  CREATE: {
    TITLE: `Créer une requête de congé`,
    SUMMARY: `Créez vos demandes de congé, votre gestionnaire devra par la suite les approuver afin qu'elles deviennent effectives.`
  },
  EDIT: { TITLE: `Modifier la requête de congé` },
  VACATIONTYPEID: {
    LABEL: `Type de congé`,
    DESCRIPTION: ``
  },
  VIEW: {
    TITLE: `Voir une requête de congé`,
    SUMMARY: ``
  },
  COMMENT: {
    LABEL: `Commentaire`,
    PLACEHOLDER: `Écrivez un commentaire`,
    DESCRIPTION: ``
  },
  START: { LABEL: `Début`, PLACEHOLDER: ``, DESCRIPTION: `` },
  END: { LABEL: `Fin`, PLACEHOLDER: ``, DESCRIPTION: `` },
  COMMENT_REQUIRED: `Un commentaire est requis.`,
  REQUEST_TYPE_ID_REQUIRED: `Veuillez sélectionner un type de congé.`,
  START_REQUIRED: `Veuillez sélectionner une date de début.`,
  END_REQUIRED: `Veuillez sélectionner une date de fin.`,
  SUBMIT: `Soumettre`,
  QUIT_PAGE: `Les modifications apportées n'ont pas été sauvegardées. Souhaitez vous quitter quand même ?`,
  END_BEFORE_START: `La date de fin doit être après la date de début.`,
  START_END_MUST_BE_DIFFERENT: `La date de début et de fin doivent être différentes.`,
  SET_PARTIAL_DAYS: `Dates partielles`,
  SET_PARTIAL_DAYS_DESC: `Permet de mettre une heure de fin et de début, plutôt que des dates complètes`,
  REQUEST_OVERLAPPING_ANOTHER: `La dates entrées chevauchent celles d'une requête de congé déjà existante.`
}
